import { TCommonData, TWidget } from '@libs/types';
import { ConditionalRender, SplitText } from '@libs/core';
import React from 'react';
import { ModalWithTimer } from '../../../UI/ModalWithTimer/ModalWithTimer';
import { TextCommon } from '../../../UI/Text/TextCommon';
import { SuccessAnimation } from '../../../Animation/SuccessAnimation';
import { ErrorAnimation } from '../../../Animation/ErrorAnimation';

type TSuccessModal = {
    text: string;
    success?: boolean;
};
export const InfoModal = ({ text, success = true }: TSuccessModal) => {
    const widget = { options: { margin: { left: 24, right: 24 } } } as TWidget<TCommonData>;
    return (
        <ModalWithTimer>
            <ConditionalRender condition={success}>
                <SuccessAnimation widget={widget} />
            </ConditionalRender>
            <ConditionalRender condition={!success}>
                <ErrorAnimation widget={widget} />
            </ConditionalRender>
            <TextCommon isWidget={false} as={'div'} options={{ margin: { top: 24 } }}>
                <SplitText text={text} as={'p'} />
            </TextCommon>
        </ModalWithTimer>
    );
};
